import { object } from 'prop-types'
import React, { useEffect, useState, useRef } from 'react'
import tableStyles from '../../styles/tracker-modules/comparevaccines.module.less'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPercent,
  faUsers,
  faClipboardCheck,
  faCheckDouble,
  faUserMd,
  faThermometerHalf,
  faSyringe,
  faVials,
  faArrowAltCircleRight,
} from '@fortawesome/free-solid-svg-icons'

const useKeys = [
  { key: 'Status', icon: faClipboardCheck },
  { key: 'Ages', icon: faUsers },
  { key: 'Doses', icon: faCheckDouble },
  { key: 'Side effects', icon: faUserMd },
  { key: 'Storage', icon: faThermometerHalf },
  { key: 'Effectiveness', icon: faPercent },
  { key: 'Booster shot?', icon: faSyringe },
  { key: 'Currently in trials', icon: faVials },
]

export default function CompareVaccines({ data, descriptionRow }) {
  let formattedData = {}
  let companies = data.map((d) => d.Company)

  data.forEach((d) => {
    formattedData[d.Company] = { ...d }
  })

  let scrollRef = useRef(null)

  //create refs for each link in the nav for scroll purposes
  let [ticking, setTicking] = useState(false)
  let [scrollRightVisible, setscrollRightVisible] = useState(true)

  function scrollNext(el) {
    //calculate scroll positions and width so that
    //we can jump forward by roughly one  chapter
    let scrollWidth = el.scrollWidth
    // let clientWidth = el.clientWidth
    let chapterWidth = scrollWidth / 7

    el.scrollLeft += chapterWidth
  }

  function scrollPrev(el) {
    //calculate scroll positions and width so that
    //we can jump forward by roughly one  chapter
    let scrollWidth = el.scrollWidth
    // let clientWidth = el.clientWidth
    let chapterWidth = scrollWidth / 7

    el.scrollLeft -= chapterWidth
  }

  //if we have a width ready for our scroller nav, set it now
  useEffect(() => {
    const initialScrollEl = scrollRef.current
    handleScroll(initialScrollEl)

    function handleScroll(el) {
      //calculate scroll positions and width so that
      //the overlay can remove when we're at the end
      let scrollWidth = el.scrollWidth
      let clientWidth = el.clientWidth
      let scrollLeft = el.scrollLeft

      if (scrollWidth - scrollLeft <= clientWidth) {
        setscrollRightVisible(false)
      } else {
        setscrollRightVisible(true)
      }
    }

    function onScrollNav(e, ticking) {
      if (!ticking) {
        window.requestAnimationFrame((d) => handleScroll(e.target))
      }

      setTicking(true)
    }

    // //add event listener to scrolling
    scrollRef.current.addEventListener('scroll', (e) => onScrollNav(e))
    window.addEventListener('resize', () => handleScroll(initialScrollEl))

    return () => {
      scrollRef.current.removeEventListener('scroll', (e) => onScrollNav(e))
      window.removeEventListener('resize', () => handleScroll(initialScrollEl))
    }
  }, [scrollRef, ticking])

  return (
    <div className={tableStyles.tableContainer}>
      <div className={tableStyles.scrollContainer} ref={scrollRef}>
        <table className={tableStyles.table}>
          <thead>
            <tr>
              <th className={tableStyles.heading}></th>
              {companies.map((key) => (
                <th className={tableStyles.top}>{key}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {useKeys.map((key) => (
              <tr>
                <th className={tableStyles.heading}>
                  <FontAwesomeIcon
                    icon={key.icon}
                    className={tableStyles.icon}
                  />
                  {key.key}
                  {descriptionRow[key] !== '' && (
                    <span
                      className={tableStyles.description}
                      dangerouslySetInnerHTML={{
                        __html: descriptionRow[key.key],
                      }}
                    ></span>
                  )}
                </th>
                {companies.map((company) => {
                  let companyData = formattedData[company]

                  return (
                    <td
                      data-label={company}
                      dangerouslySetInnerHTML={{ __html: companyData[key.key] }}
                    ></td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        className={
          scrollRightVisible ? `footnote ${tableStyles.arrow}` : 'hidden'
        }
      >
        Scroll for more{' '}
        <FontAwesomeIcon
          icon={faArrowAltCircleRight}
          className={tableStyles.icon}
        />
      </div>
    </div>
  )
}
